/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CloudBucketCosts,
    CloudBucketCostsFromJSON,
    CloudBucketCostsFromJSONTyped,
    CloudBucketCostsToJSON,
} from './';

/**
 * 
 * @export
 * @interface CloudStorageCosts
 */
export interface CloudStorageCosts {
    /**
     * 
     * @type {CloudBucketCosts}
     * @memberof CloudStorageCosts
     */
    total: CloudBucketCosts;
    /**
     * 
     * @type {{ [key: string]: CloudBucketCosts | undefined; }}
     * @memberof CloudStorageCosts
     */
    volumes: { [key: string]: CloudBucketCosts | undefined; };
}

export function CloudStorageCostsFromJSON(json: any): CloudStorageCosts {
    return CloudStorageCostsFromJSONTyped(json, false);
}

export function CloudStorageCostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudStorageCosts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': CloudBucketCostsFromJSON(json['total']),
        'volumes': (mapValues(json['volumes'], CloudBucketCostsFromJSON)),
    };
}

export function CloudStorageCostsToJSON(value?: CloudStorageCosts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': CloudBucketCostsToJSON(value.total),
        'volumes': (mapValues(value.volumes, CloudBucketCostsToJSON)),
    };
}


